export default {
  actions: {
    PROCESS_PAYOUTS: 'PROCESS_PAYOUTS',
    AUTHORIZE_PAYOUTS: 'AUTHORIZE_PAYOUTS',
    CANCEL_PAYOUTS: 'CANCEL_PAYOUTS',
  },
  getters: {
    GET_PROCESS_PAYOUT_ERRORS: 'GET_PROCESS_PAYOUT_ERRORS',
    GET_PROCESS_PAYOUT_RESPONSE: 'GET_PROCESS_PAYOUT_RESPONSE',
  },
  mutations: {
    SET_RESPONSE: 'SET_RESPONSE',
    SET_ERROR: 'SET_ERROR',
    CLEAR_STATE: 'CLEAR_STATE',
  },
};
